export default __webpack_public_path__ + "static/media/flag-cameroon.6e844022.svg";